import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal } from '_zari/core'

import * as ActivosFijosService from 'services/activosFijos.service'

import * as FormGroups from './formGroups'

const ImportarModal = ({ handleClose, show, reload }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    const submitData = new FormData()
    submitData.append('file', data.file)

    ActivosFijosService.importarActivosFijos(submitData)
      .then(() => {
        __zariContext.snack('success', 'Se han actualizados los activos fijos.')
        reload()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR ACTIVOS FIJOS</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <FormGroups.FileFormGroup fIsSubmitting={isSubmitting} setFieldValue={setFieldValue} iError={errors.file} iTouched={touched.file} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarModal
